var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.20703H14.6667",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48 1.83398H13.1867C14.3733 1.83398 14.6667 2.12732 14.6667 3.30065V6.04065C14.6667 7.21399 14.3733 7.50732 13.1867 7.50732H9.48C8.29333 7.50732 8 7.21399 8 6.04065V3.30065C8 2.12732 8.29333 1.83398 9.48 1.83398Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 11.873H8.00065",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81399 9.5H6.52065C7.70732 9.5 8.00065 9.79333 8.00065 10.9667V13.7067C8.00065 14.88 7.70732 15.1733 6.52065 15.1733H2.81399C1.62732 15.1733 1.33398 14.88 1.33398 13.7067V10.9667C1.33398 9.79333 1.62732 9.5 2.81399 9.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6647 10.498C14.6647 13.078 12.578 15.1647 9.99805 15.1647L10.698 13.998",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 6.4987C1.33203 3.9187 3.4187 1.83203 5.9987 1.83203L5.29871 2.9987",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon1);
export default __webpack_public_path__ + "static/media/transactionsIcon1.4c87e9c0.svg";
export { ForwardRef as ReactComponent };